import React from 'react'

const Social = () => {
    return (
        <>
            <div className="home__social">
                <a href="https://www.instagram.com/zainaly_" className="home__social-icon" target='_blank' rel="noreferrer">
                    <i class="uil uil-instagram"></i>
                </a>

                <a href="https://www.facebook.com/zainaly0/" className="home__social-icon" target='_blank' rel="noreferrer">
                    <i class="uil uil-facebook"></i>
                </a>


                <a href="https://www.Twitter.com/zainaly_" className="home__social-icon" target='_blank' rel="noreferrer">
                    <i class="uil uil-twitter"></i> 
                </a>
                
            </div>
        </>
    )
}

export default Social

